import { useId, type ReactElement } from 'react';

// Campo de texto de formulario con su error y su ayuda enlazados (aria-invalid +
// aria-describedby): el lector de pantalla anuncia ambos sin que cambie el nombre
// del campo. Compartido por los formularios de documentos y de catálogos.

export function TextField({
  label,
  value,
  onChange,
  error,
  maxLength,
  placeholder,
  mono = false,
  hint,
  disabled = false,
  inputMode,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error: string | null;
  maxLength: number;
  placeholder?: string;
  /** Tipografía monoespaciada (códigos). */
  mono?: boolean;
  /** Ayuda permanente bajo el campo (formato esperado, equivalencias). */
  hint?: string;
  disabled?: boolean;
  inputMode?: 'text' | 'numeric' | 'decimal';
}): ReactElement {
  const id = useId();
  const errorId = `${id}-err`;
  const hintId = `${id}-hint`;
  const describedBy =
    [error === null ? null : errorId, hint === undefined ? null : hintId]
      .filter((x) => x !== null)
      .join(' ') || undefined;
  return (
    <div className="fld">
      <label htmlFor={id} className="fld-lab">
        {label}
      </label>
      <input
        id={id}
        className={`selector fw${mono ? ' mono' : ''}`}
        value={value}
        maxLength={maxLength}
        placeholder={placeholder}
        autoComplete="off"
        disabled={disabled}
        inputMode={inputMode}
        aria-invalid={error !== null}
        aria-describedby={describedBy}
        onChange={(e) => onChange(e.target.value)}
      />
      {error !== null && (
        <span id={errorId} className="fld-err">
          {error}
        </span>
      )}
      {hint !== undefined && (
        <span id={hintId} className="fld-hint">
          {hint}
        </span>
      )}
    </div>
  );
}
